'use client';

import { Button, useTranslation } from '@payloadcms/ui';
import React from 'react';
import { LlmApp } from '../../api/types';
import './Llm.scss';

export const LlmLinksApp_ = ({ app }: { app: LlmApp }) => {
  const { t } = useTranslation<any, any>();

  const linksGroups = app.linksGroups?.filter((x) => x.links.length > 0);

  const handleClick = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <>
      {linksGroups && linksGroups.length > 0 && (
        <div className="llm-links-groups">
          {linksGroups.length > 0 ? (
            <>
              {linksGroups.map((linksGroup) => (
                <div className="llm-links-group" key={linksGroup.title}>
                  <div className="llm-link-group-title">{linksGroup.title}</div>
                  <div className="llm-links">
                    {linksGroup.links.map((link) => (
                      <Button key={link.url} onClick={() => handleClick(link.url)}>
                        {link.title}
                      </Button>
                    ))}
                  </div>
                </div>
              ))}
            </>
          ) : (
            <p>{t('general:emptyLlmAppLinks')}</p>
          )}
        </div >
      )}
    </>
  );
};

export const LlmLinksApp = React.memo(LlmLinksApp_);
